import { Select } from 'antd';
import { useEmpresa, EMPRESA_TODAS } from '../empresa';

export function EmpresaSelector() {
  const { rfc, setRfc, empresas, loading } = useEmpresa();

  return (
    <Select
      value={rfc}
      onChange={setRfc}
      loading={loading}
      style={{ minWidth: 260 }}
      options={[{ value: EMPRESA_TODAS, label: 'Todas las empresas' }, ...empresas]}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      placeholder="Seleccione una empresa"
    />
  );
}
